module.exports = __webpack_public_path__ + "img/arrow-left.7ded5233.svg";